import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { Card, CardMedia, CardContent, Typography, Box, Grid, Tooltip, tooltipClasses } from '@mui/material';

const FileUploader = ({ formik, name, label, accept, fileType, setFileType, filePreview, setFilePreview, isRequired, tooltipMsg }) => {

    const [error, setError] = useState('');

    const onDrop = (acceptedFiles) => {
        const file = acceptedFiles[0];
        if (!file) return;

        const objectUrl = URL.createObjectURL(file);
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        const isExcel = file.type === 'text/csv' ||
            file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const resetFile = (message) => {
            setError(message);
            setFilePreview(null);
            setFileType(null);
            formik.setFieldValue(name, null);
            formik.setFieldTouched(name, true, true);
            formik.validateForm();
        };

        if (isImage) {
            const img = new Image();
            img.onload = () => {
                const { width, height } = img;
                const aspectRatio = width / height;
                const expectedRatio = 720 / 1200;
                const tolerance = 0.05;
                console.log("width, height", width, height);

                setFilePreview(objectUrl);
                setFileType('image');
                setError('');
                formik.setFieldValue(name, file);
            };
            img.onerror = () => resetFile('Failed to load image.');
            img.src = objectUrl;
        }
        else if (isVideo) {
            const video = document.createElement('video');
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                setFilePreview(objectUrl);
                setFileType('video');
                setError('');
                formik.setFieldValue(name, file);
            };
            video.onerror = () => resetFile('Failed to load video.');
            video.src = objectUrl;

        } else if (isExcel) {
            setFilePreview(file.name);
            setFileType('excel');
            setError('');
            formik.setFieldValue(name, file);
        }

        formik.setFieldTouched(name, true, true);
        formik.validateForm();
    };
    useEffect(() => {
        return () => {
            if (filePreview && fileType === 'video') {
                URL.revokeObjectURL(filePreview);
            }
        };
    }, [filePreview, fileType]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: accept,
        maxFiles: 1
    });
    useEffect(() => {
        formik.setFieldTouched(name, true, true)
    }, [formik.values.media])

    return (
        <Box>
            <Grid container spacing={2} className="mt-3">
                <Grid item  lg={6} md= {6} sm= {6} xs= {12} >
                    <Tooltip title={tooltipMsg}>
                        <Box
                            {...getRootProps()}
                            className={`file-uploader ${formik.touched[name] && formik.errors[name] ? "file-uploader-validate" : ""}`}
                            sx={{
                                border: formik.touched[name] && formik.errors[name] ? '1px solid red' : '1px dashed #425e0ae8',
                            }}
                        >
                            <input {...getInputProps()} />

                            <Typography variant="h4" color="textSecondary">+</Typography>
                            <Typography color='primary'>{label}</Typography>
                            <Typography color='primary'>Or Drag/drop{isRequired && <span className='danger-validation'>*</span>}</Typography>
                        </Box>
                    </Tooltip>
                </Grid>

                {filePreview && (
                    <Grid item lg={6} md= {4} sm= {6} xs= {12}>
                        <Card sx={{ height: 150, position: 'relative', border: '1px dashed #ccc', backgroundColor: '#fafafa' }}>
                            {fileType === 'image' ? (
                                <CardMedia
                                    component="img"
                                    image={filePreview}
                                    alt="Uploaded Preview"
                                    sx={{ width: '100%', height: '80%', objectFit: 'cover' }}
                                />
                            ) : fileType === 'video' ? (
                                <CardMedia
                                    component="video"
                                    controls
                                    src={filePreview}
                                    sx={{ width: '100%', height: '80%', objectFit: 'cover' }}
                                />
                            ) : fileType === 'excel' ? (
                                <Box className="d-flex flex-column align-items-center justify-content-center" sx={{ height: '100%' }}>
                                    <Typography variant="body2" color="textSecondary">
                                        📄 Uploaded File
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                        <strong>{filePreview}</strong>
                                    </Typography>
                                </Box>
                            ) : null}

                            <Box
                                onClick={() => {
                                    setFilePreview(null);
                                    setFileType(null);
                                    setError('')
                                    formik.setFieldValue(name, null);
                                }}
                                className="remove-button"
                            >
                                ✕
                            </Box>

                            <CardContent sx={{ textAlign: 'center', p: 1 }}>
                                <Typography variant="body2" color="text.secondary">
                                    Preview
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                )}

            </Grid>
            <div className='validation-wrapper mt-1'>
                {error &&
                    <>
                        {error}
                    </>}
                {!error && formik.touched[name] && formik.errors[name] && (
                    <>
                        {formik.errors[name]}
                    </>
                )}
            </div>
        </Box>
    );
};

export default FileUploader;
